import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const ProtectedRoute = ({ redirectTo = '/login' }) => {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="p-8 text-center">
          <div className="flex justify-center mb-4">
            <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-orange-500"></div>
          </div>
          <h2 className="text-xl font-semibold">Verifying your session...</h2>
          <p className="text-gray-500 mt-2">
            Please wait while we authenticate your credentials.
          </p>
        </div>
      </div>
    )
  }

  // Handle the redirectTo case for the root route
  if (location.pathname === '/' && redirectTo !== '/login') {
    return <Navigate to={redirectTo} replace />
  }

  // Either render the protected content or redirect to login
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />
}

export default ProtectedRoute
